import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  linkText?: string;
  linkTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  linkText,
  linkTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <span className="inline-block text-xs tracking-[0.2em] text-accent-700 font-medium mb-2">
            {eyebrow}
          </span>
        )}
        <h2 className="text-2xl md:text-3xl font-semibold text-foreground-900">{title}</h2>
        {description && (
          <p className="mt-2 text-sm text-foreground-500 max-w-2xl leading-relaxed">{description}</p>
        )}
      </div>
      {linkText && linkTo && (
        <Link
          to={linkTo}
          className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
        >
          {linkText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}